import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Link to the Contact page. Scrolling to top is handled globally
 * by the ScrollToTop component.
 */
const ContactLink = ({ children, className }) => (
  <Link to="/contact" className={className}>
    {children || 'Contact'}
  </Link>
);

export default ContactLink;
